import React, { useEffect, useState } from "react";
import { Redirect, useParams } from "react-router-dom";
import { Box, Button, CssBaseline, Dialog, DialogActions, DialogContent, Grid, Typography } from "@mui/material";
import MetaDecorator from "../../services/meta_decorator";
import NDReferralHeader from "../../components/shared/ndreferralheader";
import { getApiUrl } from "../../services/api_service";
import Footer from "../../components/shared/footer";
import { blackcolor, bodyBg, footerContainer, fullHeight, headerText, orangecolor, rcolor, whitecolor } from "../../style2";

export default function WhoAreYou() {
    const { orgCode } = useParams();
    const [redirect, setRedirect] = useState('');
    const [showParentModal, setShowParentModal] = useState(false);
    const [error, setError] = useState('');
    const [isLoggedIn, setLoggedIn] = useState(false);


    useEffect(() => {
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            return;
        }
        fetch(getApiUrl() + "/ReferrerAccount/istokenvalid", {
            method: "get",
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },

        }).then(resp => {
            if (resp.status === 200) {
                setLoggedIn(true);
            }
        }).catch(err => {
            setError('Unable to contact server. Check your internet connection.');
            console.log(err);
        });
    }, [])

    if (redirect !== "")
        return <Redirect to={redirect} />;
    else
        return <Box sx={{ ...bodyBg, ...fullHeight }}>
            <CssBaseline />
            <MetaDecorator title={"EnrichMyCare - Make A Referral"} description={"EnrichMycare Make Refferal"} />
            <NDReferralHeader date={Date.UTC()} orgCode={orgCode} isLoggedIn={isLoggedIn} logo="../../Logo_Option_1.svg" />
            <Box sx={{ width: "100%", padding: "3rem 10rem" }}>
                <Typography variant="h5" sx={{...headerText, paddingBottom: "30px", fontWeight: "bold", fontSize: "2rem" }}>
                    I am...
                </Typography>
                {error !== "" ? <Box mt={1} mb={2} style={{ color: rcolor, fontSize: "1.1rem", textAlign: "center" }}>{error}</Box> : null}
                <Grid container fullHeight>
                    <Grid xs={6} item>
                        <Box p={5}>
                            <Box onClick={() => {
                                setRedirect(`/referral/login/${orgCode}`);
                            }} sx={{
                                cursor: "pointer", background: whitecolor, padding: "5rem", border: `3px solid ${blackcolor}`,
                                ':hover': {
                                    background: '#fdfdfd',
                                },
                            }}>
                                <Typography variant="h5" style={{ color: orangecolor, fontWeight: "bold" }}>Education Staff</Typography>
                                <Typography>(SENCO/Teachers)</Typography>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid xs={6} item>
                        <Box p={5}>
                            <Box sx={{ background: whitecolor, padding: "5rem", border: `3px solid ${blackcolor}` }}>
                                <Typography variant="h5" style={{ color: orangecolor, fontWeight: "bold" }}>Healthcare Professionals</Typography>
                                <Typography>(GP/Therapists/Health Visitors)</Typography>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid xs={6} item>
                        <Box p={5}>
                            <Box sx={{ background: whitecolor, padding: "5rem", border: `3px solid ${blackcolor}`, marginRight: "3rem" }}>
                                <Typography variant="h5" style={{ color: orangecolor, fontWeight: "bold" }}>Other Professionals</Typography>
                                <Typography>(Third Sector)</Typography>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid xs={6} item>
                        <Box p={5}>
                            <Box onClick={() => { setShowParentModal(true); }} sx={{
                                cursor: "pointer", background: whitecolor, padding: "5rem", border: `3px solid ${blackcolor}`,
                                marginRight: "3rem",
                                ':hover': {
                                    background: '#fdfdfd',
                                },
                            }}>
                                <Typography variant="h5" style={{ color: orangecolor, fontWeight: "bold" }}>Parent/Carer</Typography>
                                <Typography>&nbsp;</Typography>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
                <Dialog onClose={() => { setShowParentModal(false); }}
                    open={showParentModal}
                    fullWidth={true}
                    maxWidth={"md"}>
                    <DialogContent>
                        <Typography style={{ color: orangecolor, textAlign: "left", fontSize: "1.5rem", fontWeight: 'bold', marginBottom: "1.2rem", marginTop: "1rem" }}>Contact your child’s Nursery/School SENCO</Typography>
                        <Typography style={{ marginBottom: "1rem", textAlign: "left" }}>Parents/Carers cannot directly make a referral.
                        </Typography>
                        <Typography style={{ marginBottom: "1rem", textAlign: "left" }}>
                            Speak to your child’s Nursery/School SENCO and request them to refer your child.
                        </Typography>
                        <Typography style={{ marginBottom: "2rem", textAlign: "left" }}>
                            As part of the referral process, parents/carers will be requested to complete a parent questionnaire.</Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { setShowParentModal(false); }}>Close</Button>
                    </DialogActions>
                </Dialog>
            </Box>
            <Box sx={{...footerContainer, position:"static"}}>
                <Footer />
            </Box>
        </Box>;
}